<template>
  <div class="matter-load-container">

    <IconsLoader size="md"
                 class="app-loader"
                 v-if="loadingMatter"/>

    <NoResultsCmp v-if="!loadingMatter && !matter"
                  icon="icon-warning"
                  :text="$t(`${clientPageText}load_error`)"
                  :action-text="$t(`${clientPageText}load_action`)"
                  @action-click="fetchMatterData()"/>

    <div v-if="!loadingMatter && matter"
         class="matter-page-wrapper"
         :class="{ 'matter-page-wrapper--sidepane': sidePaneOpen }">
      <MatterInfo :matter="matter"
                  :direction="direction"/>
      <MatterEngagements :chosen-tab="activeTab"
                         :matter="matter"
                         @change="tabChange"/>
      <SidePaneDrawer @sidepane-toggle="sidePaneToggle()"
                      :side-pane-open="sidePaneOpen"
                      :direction="direction"
                      :open-button-color="primaryColor">
        <div class="loader-wrapper"
             v-if="!currContact">
          <VcLoader class="circular-loader"/>
        </div>
        <ContactInfo v-if="currContact"
                     :contact="currContact"
                     :direction="direction"/>
      </SidePaneDrawer>
    </div>
  </div>
</template>

<script>
  import {MatterInfo, MatterEngagements, ContactInfo} from '@/modules/matters/components';
  import {SidePaneDrawer, IconsLoader, NoResultsCmp} from "@/modules/common/components";
  import {storageService} from "@/modules/common/services";
  import {mapGetters} from "vuex";
  import {postMessageService} from "@/modules/common/services";

  export default {
    name: 'MatterPage',
    components: {
      SidePaneDrawer,
      MatterInfo,
      MatterEngagements,
      ContactInfo,
      IconsLoader,
      NoResultsCmp
    },
    props: {
      activeTab: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        clientPageText: 'client.matters.matter_page.',
        sidePaneOpen: storageService.get('sidePaneOpen') !== null ? storageService.get('sidePaneOpen') : true
      }
    },
    async created(){
      await this.$store.dispatch({type: 'quickActionsModule/loadActions'});
      postMessageService.post('app_loaded')
    },
    computed: {
      ...mapGetters(['direction']),
      ...mapGetters('mattersModule', ['matter', 'activeMatterTab', 'currContact', 'loadingMatter']),
      ...mapGetters("brandModule", ["primaryColor"])
    },
    methods: {
      fetchMatterData() {
        this.$store.dispatch({type: 'mattersModule/fetchMatterData', payload: {matterUid: this.matter && this.matter.uid || this.matterUid}});
      },
      sidePaneToggle() {
        this.$track(this.sidePaneOpen ? 'Collapse client card right pane' : 'Expand client card right pane');
        this.sidePaneOpen = !this.sidePaneOpen;
        storageService.save('sidePaneOpen', this.sidePaneOpen);
      },
      tabChange(tab) {
        this.$store.dispatch({type: 'mattersModule/saveMatterTab', payload: {tab: tab}});
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .matter-load-container {
    height: 100%;
  }

  .matter-page-wrapper {
    background-color: $grey-color-3;
    height: 100%;
    width: 100%;
    padding: 20px;
    display: flex;
    font-family: var(--primary-font-family);
    transition: width 0.3s;

    &--sidepane {
      width: calc(100% - 300px);

      @include under-supported-size {
        width: calc(100% - 265px);
      }
    }

    .v-card:not(.contact-info) {
      height: calc(100vh - 40px);
      display: inline-block;
    }

    ::v-deep .empty-state {
      color: $grey-color-6;
      padding: 28px 0;

      &.empty-matter-fields {
        padding: 15px 0;
      }

      &.non-empty {
        padding: 5px 0;
      }

      &-content {
        position: relative;
        @include i-position-mirror(left, 50%);
        @include i-translate-x(-50%);
        width: fit-content;
      }

      &-title {
        font-weight: 600;
      }

      &-cta {
        padding-top: 5px;
        color: $blue-color-4;
        font-weight: 500;
        cursor: pointer;

        .v-icon {
          color: $blue-color-4;
          font-size: 16px;
          top: -2px;
        }
      }
    }

    .side-pane-wrapper {

      .side-pane {

        .loader-wrapper {
          height: 100%;
          text-align: center;

          .circular-loader {
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .app-loader {
    position: fixed;
    z-index: 1;
    top: 0;
  }
  .app-loader-leave-active {
    transition: opacity .5s;
  }
</style>
